import React, {useState} from 'react'
import AttributesExpansion from "./AttributesExpansion";
import {Category} from "../../reducers/project";
import {mapCategoryToAttribute} from "./AttributesDrawer";
import {useSelector} from "react-redux";
import {getCustomAttributes} from "../../reducers/project/selectors";

function CustomExpanders({expanded, toggleExpand}: any) {
  const expandTable = ['Typ', 'Regulacja', 'Rodzaj', 'Opaska', 'Kąt łączenia']


  const toggleNext = () => {

  };

  return (
  <>
    <AttributesExpansion
      name={'Typ'}
      multi={true}
      expandedName={'Typ'}
      toggleExpand={toggleExpand}
      toggleNext={toggleNext}
      custom={true}
      expanded={'Typ' === expanded || expanded === Category.Custom}
      attr={[{
        id: 'type',
        slug: 'mdf',
        name: "MDF",
        tags:'',
        price: '',
        simg: '$/static/img/ico_osc_mdf.jpg',
        category: Category.Custom,
      },
        {
          id: 'type',
          slug: 'steel',
          name: "STALOWE",
          tags:'',
          price: '',
          simg: '$/static/img/ico_osc_stal.jpg',
          category: Category.Custom,
        }] as any}
    />
    <AttributeWrapper
      name={'Regulacja'}
      expandTable={expandTable}
      currentActive={expanded}
      multi={true}
      expandedName={'Regulacja'}
      toggleExpand={toggleExpand}
      toggleNext={toggleNext}
      custom={true}
      expanded={'Regulacja' === expanded}
      attr={[{
        id: 'regulation',
        slug: 'regulable',
        name: "REGULOWANA",
        tags:'',
        price: '',
        simg: '$/static/img/ico_osc_regulowana.jpg',
        category: Category.Custom,
      },
        {
          id: 'regulation',
          slug: 'still',
          name: "STAŁA",
          tags:'',
          price: '',
          simg: '$/static/img/ico_oscieznica_stala.jpg',
          category: Category.Custom,
        }] as any}
    />
    <AttributeWrapper
      name={'Rodzaj'}
      multi={true}
      expandedName={'Rodzaj'}
      expandTable={expandTable}
      currentActive={expanded}
      toggleExpand={toggleExpand}
      toggleNext={toggleNext}
      custom={true}
      expanded={'Rodzaj' === expanded}
      attr={[{
        id: 'kind',
        slug: 'rebated',
        name: "PRZYLGOWA",
        tags:'',
        price: '',
        simg: '$/static/img/ico_przylgowe.jpg',
        category: Category.Custom,
      },
        {
          id: 'kind',
          slug: 'non-rebated',
          name: "BEZPRZYLGOWA",
          tags:'',
          price: '',
          simg: '$/static/img/ico_bezprzylgowe.jpg',
          category: Category.Custom,
        },
        {
          id: 'kind',
          slug: 'reverse',
          name: "REWERSYJNA",
          tags:'',
          price: '',
          simg: '$/static/img/ico_rewersyjne.jpg',
          category: Category.Custom,
        }] as any}
    />
    <AttributeWrapper
      name={'Opaska'}
      multi={true}
      expandedName={'Opaska'}
      expandTable={expandTable}
      currentActive={expanded}
      toggleExpand={toggleExpand}
      toggleNext={toggleNext}
      custom={true}
      expanded={'Opaska' === expanded}
      attr={[{
        id: 'band',
        slug: '6',
        name: "6 cm",
        tags:'',
        simg: '$/static/img/ico_6cm_opaska.jpg',
        price: '',
        category: Category.Custom,
      },
        {
          id: 'band',
          slug: '8',
          name: "8 cm",
          tags:'',
          simg: '$/static/img/ico_8cm_opaska.jpg',
          price: '',
          category: Category.Custom,
        }] as any}
    />
    <AttributeWrapper
      name={'Kąt łączenia'}
      multi={true}
      expandedName={'Kąt łączenia'}
      expandTable={expandTable}
      currentActive={expanded}
      toggleExpand={toggleExpand}
      toggleNext={toggleNext}
      custom={true}
      expanded={'Kąt łączenia' === expanded}
      attr={[{
        id: 'angle',
        slug: '45',
        name: "45°",
        simg: '$/static/img/ico_45stopni.jpg',
        tags:'',
        price: '',
        category: Category.Custom,
      },
        {
          id: 'angle',
          slug: '90',
          name: "90°",
          simg: '$/static/img/ico_90stopni.jpg',
          tags:'',
          price: '',
          category: Category.Custom,
        }] as any}
    />
    <AttributeWrapper
      name={'Z opaską'}
      multi={true}
      expandedName={'Z opaską'}
      expandTable={expandTable}
      currentActive={expanded}
      toggleExpand={toggleExpand}
      toggleNext={toggleNext}
      custom={true}
      expanded={'Z opaską' === expanded}
      attr={[{
        id: 'withBand',
        slug: 'true',
        name: "TAK",
        tags:'',
        price: '',
        category: Category.Custom,
      },
        {
          id: 'withBand',
          slug: 'false',
          name: "NIE",
          tags:'',
          price: '',
          category: Category.Custom,
        }] as any}
    />
  </>
 );
};

const AttributeWrapper = (props) => {
  return (props.expandTable.indexOf(props.currentActive) >= (props.expandTable.indexOf(props.expandedName) || 0)) && (props.expandedName === 'Z opaską'? props.currentActive === 'withBand':true)? <AttributesExpansion {...props}/>:<></>
}

export default CustomExpanders